// @ts-check
import React from 'react';
import { withStyles } from '@material-ui/core';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { mapProps } from 'modules/shell/hoc/mapProps';
import PageLayout from './PageLayout';
import styles from './PageLayout.styles';

const mapStateToProps = ({ clientingModule }) => ({
  isTopPadded: clientingModule?.voice.hasCallInProgress && clientingModule?.voice.isMinimized,
});

const PageLayoutWithRedux = connect(mapStateToProps)(PageLayout);

const BaseComponent = ({ Component, ...props }) => <Component {...props} />;

BaseComponent.displayName = 'PageLayout';

const PageLayoutContainer = compose(
  mapProps(({ withoutRedux, ...restProps }) => {
    const Component = withoutRedux ? PageLayout : PageLayoutWithRedux;

    return {
      ...restProps,
      Component,
    };
  }),
  // @ts-ignore
  withStyles(styles),
)(BaseComponent);

/**
 * @typedef {React.ComponentPropsWithoutRef<PageLayout>} PageLayoutProps
 * @param {Partial<PageLayoutProps>} props
 * @param {React.Ref<any>} ref
 * @returns {React.ReactElement<PageLayout>}
 */
const forwardRefCallback = (props, ref) => <PageLayoutContainer {...props} pageLayoutRef={ref} />;

const ForwardedPageLayoutContainer = React.forwardRef(forwardRefCallback);

ForwardedPageLayoutContainer.displayName = 'PageLayoutContainer';

export default ForwardedPageLayoutContainer;
